import React from 'react'

const Footer = ({ footerId }) => {
  return (
    <div className="flex flex-row justify-between my-full absolute bottom-5">
      <div className="mt-40 text-gray-400 whitespace-pre">{footerId}</div>
    </div>
  )
}

export default Footer
